import functions from "./functions.js";

// Google Tag Manager
$(function() {

    $('#pills-booking-tab').on('shown.bs.tab', e => {
        // if (! functions.getCookie('begin_checkout')) {
            const $target = $(e.currentTarget);
            
            let analyticsData = $target.attr('data-analytics-data');

            analyticsData = analyticsData ? JSON.parse(analyticsData) : {};
            dataLayerPush('begin_checkout', analyticsData);
            // functions.setCookie('begin_checkout', 1, (1 / 1440) * 10); // 10 minuta
        // }
    });

    $(".booking-form").on('submit', e => {
        // if (! functions.getCookie('add_payment_info')) {
            const $target = $(e.currentTarget);
            
            let analyticsData = $target.attr('data-analytics-data');
            analyticsData = analyticsData ? JSON.parse(analyticsData) : null;

            if(analyticsData) {
                dataLayerPush('add_payment_info', analyticsData);
                // functions.setCookie('add_payment_info', 1);
            }
        // }
    });

    const $tracking = $('[data-tracking]');
    if($tracking.length) {
        let trackingData = $tracking.attr('data-tracking');
        trackingData = trackingData ? JSON.parse(trackingData) : null;

        if(trackingData) {
            const event = trackingData.event;
            // delete trackingData.event;
    
            let eventCookie = functions.getCookie(event);
    
            if(! eventCookie || (eventCookie && eventCookie != trackingData.booking_id)) {
                dataLayerPush(event, trackingData);
                functions.setCookie(event, trackingData.booking_id);
            }
        }
    }

    function dataLayerPush(event, analyticsData) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({ event, ...analyticsData });
    }

    /*$('[data-analytics-event="checkout"]').on('click', e => {
        const units = $('.unit-title');
        let items = [];
        let total = $('[data-carttotal]').attr('data-carttotal');
        const dataCurrency = $('[data-currency]').attr('data-currency');

        units.each((index, unit) => {
            const $unit = $(unit);
            const unitId = $unit.attr('data-unitid');
            const unitName = $('.unit-title').attr('data-cabinname');
            const objectName = $('.object-name').attr('data-objectname');
            // old: Cruise Adriatic Discovery A - Cristal Cabin for 2 persons
            // new: Adriatic Inspiration B Fenix - Kabina za 2 osobe Donja paluba
            const name = objectName + ' ' + unitName;
            let unitTotal = $('.item-total-amount[data-unitid=' + unitId + ']').attr('data-itemtotal');
            unitTotal = functions.formatMoney(unitTotal, 2, '.', '');

            items.push({
                'id': unitId,
                'name': name,
                'total': unitTotal,
            });

        });
        dataLayer.push({ 'ecommerce': null });

        dataLayer.push({
            'event': 'checkout',
            'analytics': 'GA4',
            'currency': dataCurrency,
            'total': functions.formatMoney(total, 2, '.', ''),
            'ecommerce': {
                'event_category': 'Ecommerce',
                'items': items
            }
        });

    });*/
    
    // success, cancelled, error
    /*if($('[data-analytics-purchase]')[0]) {
        let purchase = $('[data-analytics-purchase]').attr('data-analytics-purchase');
        purchase = JSON.parse(purchase);

        dataLayer.push({ 'ecommerce': null });

        if(purchase.paymentStatus) {
            dataLayer.push({
                'event': 'purchase',
                'analytics': 'GA4',
                'currency': purchase.currency,
                'total': purchase.total,
                'ecommerce': {
                    'event_category': 'Ecommerce',
                    'items': purchase.items
                }
            });
            console.log(dataLayer);
        } else {
            dataLayer.push({'event': 'purchase_canceled'});
        }

        //console.log(dataLayer);
    }*/
});
